// Array to store the references to the event listeners for cleanup
let eventListeners = [];
var preloadedImages = [];

// Function to initialize swatch hover listeners
function initializeSwatchHoverListeners() {
    //console.log('Initializing swatch hover listeners...');
    removeExistingListeners(); // Clear previous listeners before adding new ones

    var productCards = document.querySelectorAll('.card-product-custom-div');

    productCards.forEach(function (card) {
      
        var colorSwatches = card.querySelectorAll('.color-swatch');
        var productImageElement = card.querySelector('.--custom-primary-image');
        var productSecondaryImageElement = card.querySelector('.--custom-secondary-image');
        var detectProductImageElement = card.querySelector('.card');

        // Set default image URLs and srcset values from the product's initial state
        var defaultPrimaryImageUrl = productImageElement.src;
        var defaultPrimaryImageSrcset = productImageElement.srcset;
        var defaultSecondaryImageUrl = productSecondaryImageElement ? productSecondaryImageElement.getAttribute('data-hover-image-url') : null;
        var defaultSecondaryImageSrcset = productSecondaryImageElement ? productSecondaryImageElement.srcset : null;

        // Track the URLs and srcsets for the last hovered swatch, initializing with the default images
        var lastHoveredPrimaryImageUrl = defaultPrimaryImageUrl;
        var lastHoveredPrimaryImageSrcset = defaultPrimaryImageSrcset;
        var lastHoveredSecondaryImageUrl = defaultSecondaryImageUrl;
        var lastHoveredSecondaryImageSrcset = defaultSecondaryImageSrcset;

        // Add event listeners to color swatches
        colorSwatches.forEach(function (swatch) {
            var swatchPrimaryImageUrl = swatch.getAttribute('data-image-url');
            var swatchSecondaryImageUrl = swatch.getAttribute('data-hover-image-url');
            var swatchProductTitle = swatch.getAttribute('data-product-title');
            var swatchProductTitleAlt = swatch.getAttribute('data-product-title-alt');
            var swatchProductUrl = swatch.getAttribute('data-product-url');
            var swatchProductPrice = swatch.getAttribute('data-product-price');
            var swatchProductPriceCompare = swatch.getAttribute('data-product-compare-at-price');

            if (swatchPrimaryImageUrl) {
              preloadImage(swatchPrimaryImageUrl); // Preload primary image
              if (swatchSecondaryImageUrl) {
                  preloadImage(swatchSecondaryImageUrl); // Preload secondary image if available
              }
            }

            if (swatchPrimaryImageUrl) {
                // Define mouseover handler function
                const handleMouseOver = function () {
                    // Change the product image to the swatch's primary image
                    if (productImageElement) {
                        productImageElement.src = swatchPrimaryImageUrl;
                        productImageElement.srcset = generateSrcset(swatchPrimaryImageUrl);
                    }

                    // Change the secondary image
                    if (productSecondaryImageElement && swatchSecondaryImageUrl) {
                        productSecondaryImageElement.src = swatchSecondaryImageUrl;
                        productSecondaryImageElement.srcset = generateSrcset(swatchSecondaryImageUrl);
                    }

                    // Remove the 'last-hovered' class from the previously hovered swatch
                    var lastHoveredSwatch = card.querySelector('.outer-circle.last-hovered');
                    if (lastHoveredSwatch && lastHoveredSwatch !== swatch.closest('.outer-circle')) {
                        lastHoveredSwatch.classList.remove('last-hovered');
                    }

                    // Add the 'last-hovered' class to the currently hovered swatch
                    swatch.closest('.outer-circle').classList.add('last-hovered');

                    // Update the product title and link
                    if (swatchProductTitleAlt != null) {
                        updateProductInfo(card, swatchProductTitleAlt, swatchProductUrl, swatchProductPrice, swatchProductPriceCompare);
                    } else {
                        updateProductInfo(card, swatchProductTitle, swatchProductUrl, swatchProductPrice, swatchProductPriceCompare);
                    }

                    handleBadge(card, swatch);
                };

                // Add mouseover event and store it in the eventListeners array
                swatch.addEventListener('mouseover', handleMouseOver);
                eventListeners.push({ element: swatch, event: 'mouseover', handler: handleMouseOver });
            }
        });

        // Add hover event listener to the product image
        const handleProductMouseOver = function () {
            if (productSecondaryImageElement && lastHoveredSecondaryImageUrl) {
                productSecondaryImageElement.src = lastHoveredSecondaryImageUrl;
                productSecondaryImageElement.srcset = lastHoveredSecondaryImageSrcset;
            }
        };

        detectProductImageElement.addEventListener('mouseover', handleProductMouseOver);
        eventListeners.push({ element: detectProductImageElement, event: 'mouseover', handler: handleProductMouseOver });

        // Add mouseout event listener to reset the product image on mouse leave
        const handleProductMouseOut = function () {
            if (productImageElement) {
                productImageElement.src = lastHoveredPrimaryImageUrl;
                productImageElement.srcset = lastHoveredPrimaryImageSrcset;
            }
            if (productSecondaryImageElement) {
                productSecondaryImageElement.src = lastHoveredSecondaryImageUrl;
                productSecondaryImageElement.srcset = lastHoveredSecondaryImageSrcset;
            }
        };

        detectProductImageElement.addEventListener('mouseout', handleProductMouseOut);
        eventListeners.push({ element: detectProductImageElement, event: 'mouseout', handler: handleProductMouseOut });
    });
}

// Function to observe DOM changes in the ProductGridContainer
function observeProductGridContainer() {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) {
        console.error('ProductGridContainer not found');
        return;
    }

    // Create a MutationObserver to watch for changes in the ProductGridContainer
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                //console.log('ProductGridContainer structure changed (element added or removed)');
                removeExistingListeners(); // Cleanup old listeners
                initializeSwatchHoverListeners(); // Reinitialize swatch listeners when the grid changes
                break;
            }
        }
    });

    observer.observe(productGridContainer, {
        childList: true, // Only observe added/removed child elements
        subtree: true    // Watch all descendant elements, not just direct children
    });
}

function removeExistingListeners() {
    eventListeners.forEach(listener => {
        listener.element.removeEventListener(listener.event, listener.handler);
    });
    // Clear the eventListeners array after removing them
    eventListeners = [];
}

// Preload image helper function
function preloadImage(url) {
    var img = new Image();
    img.src = url;
    preloadedImages.push(img); // Add preloaded image to the array
}

// Helper function to generate srcset values dynamically
function generateSrcset(imageUrl) {
    if (!imageUrl) return '';
    return `
        ${imageUrl.replace('_533x533', '_165x165')} 165w,
        ${imageUrl.replace('_533x533', '_360x360')} 360w,
        ${imageUrl.replace('_533x533', '_533x533')} 533w,
        ${imageUrl.replace('_533x533', '_720x720')} 720w,
        ${imageUrl.replace('_533x533', '_940x940')} 940w,
        ${imageUrl.replace('_533x533', '_1066x1066')} 1066w,
        ${imageUrl} 1334w
    `;
}

// Helper function to update the product title and link
function updateProductInfo(card, title, url, price, comparePrice) {
    var titleElement = card.querySelector('h3.title-linked-to-swatch a');
    var imageLinkElement = card.querySelector('h3.image-linked-to-swatch a');
    var priceElement = card.querySelector('.price__regular');
    var comparePriceElement = card.querySelector('.price__sale');

    var currency = Shopify.currency.active || 'GBP';

    if (title && titleElement) {
        titleElement.textContent = title;
    }
    
    if (url) {
        if (titleElement) {
            titleElement.href = url;
        }
        if (imageLinkElement) {
            imageLinkElement.href = url;
        }
    }

    if (priceElement) {
        priceElement.textContent = formatCurrency(price); // Update displayed price
    }

    if (comparePriceElement) {
        if (comparePrice > price) {
            comparePriceElement.style.display = 'inline-block'; // Show sale price
            priceElement.style.display = 'inline-block'; // Hide regular price

            var sTag = comparePriceElement.querySelector('s');
            if (sTag && sTag.textContent.trim() === '') {
                sTag.textContent = formatCurrency(comparePrice, currency);
                comparePriceElement.appendChild(sTag);
            }
            sTag.textContent = formatCurrency(comparePrice, currency);
        } else {
            comparePriceElement.style.display = 'none'; // Hide sale price
            priceElement.style.display = 'inline-block'; // Show regular price
        }
    }
}

function formatCurrency(price, currency = Shopify.currency.active) {
    let formattedPrice = (parseFloat(price) / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency,
    });

    // Remove any letter prefix before the currency symbol (e.g., "A$", "CA$", "US$")
    formattedPrice = formattedPrice.replace(/^[A-Z]{1,3}\$/, '$');

    return formattedPrice;
}

// Function to handle the badge display for the current card
function handleBadge(card, swatch) {
    var badgeElement = card.querySelector('.card__badge .badge');

    // Extract attributes from swatch
    var isAvailable = swatch.getAttribute('data-product-available') === 'true';
    var isOnSale = swatch.getAttribute('data-on-sale') === 'true';
    var discountPercentage = parseInt(swatch.getAttribute('data-discount-percentage'), 10);
    var customBadgeText = swatch.getAttribute('data-custom-badge');
    var publishedAt = new Date(swatch.getAttribute('data-published-at')); // Product publish date
    var customBadgeColorScheme = swatch.getAttribute('data-custom-badge-color-scheme');
    var soldOutBadgeColorScheme = swatch.getAttribute('data-sold-out-badge-color-scheme');
    var newInBadgeColorScheme = swatch.getAttribute('data-new-in-badge-color-scheme');
    var saleBadgeColorScheme = swatch.getAttribute('data-sale-badge-color-scheme');
    var productPrice = swatch.getAttribute('data-product-price');
    var productComparePrice = swatch.getAttribute('data-product-compare-at-price');

    // Calculate date 14 days ago
    var fourteenDaysAgo = new Date();
    fourteenDaysAgo.setDate(fourteenDaysAgo.getDate() - 14);

    // Check conditions and update the badge
    if (badgeElement) {
        console.log(customBadgeText);
        if (customBadgeText) {
            // Custom defined badge
            badgeElement.textContent = customBadgeText;
            badgeElement.className = `badge badge--bottom-left color-${customBadgeColorScheme}`;
            badgeElement.style.display = '';
        } else if (!isAvailable) {
            // Sold out badge
            badgeElement.textContent = 'Sold out';
            badgeElement.className = `badge badge--bottom-left color-${soldOutBadgeColorScheme}`;
            badgeElement.style.display = '';
        } else if (publishedAt >= fourteenDaysAgo) {
            // New in badge
            badgeElement.textContent = 'New In';
            badgeElement.className = `badge badge--bottom-left color-${newInBadgeColorScheme}`;
            badgeElement.style.display = '';
        } else if (isOnSale && discountPercentage > 0 && productComparePrice > productPrice) {
            // Sale badge with discount percentage
            badgeElement.textContent = discountPercentage + '% OFF';
            badgeElement.className = `badge badge--bottom-left color-${saleBadgeColorScheme}`;
            badgeElement.style.display = '';
        } else {
            // Hide badge if none of the conditions are met
            badgeElement.style.display = 'none';
        }
    }
}


function initializePage() {
    initializeSwatchHoverListeners();
    observeProductGridContainer();
}

if (document.readyState === 'complete') {
    // If the document is already fully loaded, initialize immediately
    initializePage();
} else {
    // Otherwise, listen for DOMContentLoaded and load events
    document.addEventListener('DOMContentLoaded', initializePage);
    window.addEventListener('load', initializePage);
}
